export default "__VITE_ASSET__BwLpFFj3__"